import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import pSifremiUnuttum from '../../../../api/models/pSifremiUnuttum';
import rCore from '../../../../api/models/rCore';

export default ApiBaseReducer<
  pSifremiUnuttum,
  IInputDataStateModel<pSifremiUnuttum, rCore>,
  boolean
>(ActionSubTypes.API_SIFREMIUNUTTUM, DefaultInputDataStateModel<pSifremiUnuttum, rCore>());
